import HTTP from '../HTTP';

const PANNEAUXLC_URL = 'PanneauxLc';
const RESEAUX_URL = 'Reseaux';

export async function getAffectationProduitUnitaireAsync(produits, avecTarif,
  avecAffectationReseau) {
  const params = {
    produits,
    avecTarif,
    avecAffectationReseau,
  };
  const response = await HTTP.post(PANNEAUXLC_URL + '/getAffectation', params);
  return response;
}

export async function getAffectationProduitReseauLc(params) {
  const response = await HTTP.post(RESEAUX_URL + '/getAffectation', params);
  return response;
}



// WEBPACK FOOTER //
// ./src/api/affectation/index.js